import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, {useState} from "react";

const headers = [
  {
    key: "present_name",
    parent: "present",
    name: "Gift Name",
  },
  {
    key: "customer_name",
    parent: "retail_customer",
    name: "Retail Customer Name",
  },
  {
    key: "qty",
    name: "Quantity",
  },
  {
    key: "created_date",
    name: "Date",
  },
  {
    key: "status",
    name: "Status",
  },
];

const detailPopupHeaders = [
  {
    key: "present_adjustment_id",
    name: "Gift Adjustment ID",
  },
  {
    key: "warehouse_name",
    parent: "warehouse",
    name: "Warehouse Name",
  },
  {
    key: "present_name",
    parent: "present",
    name: "Present Name",
  },
  {
    key: "barcode",
    name: "Barcode",
  },
  {
    key: "qty",
    name: "Quantity",
  },
  {
    key: "method",
    name: "Method",
  },
  {
    key: "adjustment_date",
    name: "Adjustment Date",
  },
  {
    key: "remark", //????
    name: "Remark",
  },
];

const RedeemedGiftList = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  // const handleSearch = (value) => {
  //   console.log("searching value: ", value);
  // };

   const [searchValue, setSearchValue] = useState("");
  
    const handleSearch = (value) => {
      //console.log("searching value: ", value);
      const trimmed = value.trim();
      if(trimmed.length > 0){
        setSearchValue(trimmed);
        setQuery({
          search: trimmed,
        });
      }else{
          setQuery({
        
      });
      }
    };

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/issuePresent",
    defaultQuery: "status=ACTIVE",
  });

   const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Redeemed Gift List"
      data={data}
      headers={headers}
      // detailPopupHeaders={detailPopupHeaders}
      setCurrentPage={setCurrentPage}
      removeDetails={true}
      idKey="giving_present_id"
      endPoint="/issuePresent"
      hasSearch
      hasCreate
      hasActions
      removeEdit
      module="Loyalty"
      subModule="Redeemed Gift List"
      createPath={`/loyalty/redeemed-gift/list/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      reload={reload}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
      setQuery={setQuery}
    />
  );
};

export default RedeemedGiftList;
